import { useGetQuery as r } from "./useGetQuery.js";
const s = () => ({
  ...r()
});
export {
  s as useOrgsQueryParams
};
